<template>
    <div id="app" :class="{ 'side-open': sidebarVisible, 'navigation-open': navigationVisible}">
        <div class="page-wrapper">
            <component v-bind:is="color"></component>
            <navigator v-if="!jail"></navigator>
            <transition name="page" mode="out-in">
                <router-view :key="$route.path"></router-view>
            </transition>
            <footer-section v-if="!footerHidden"></footer-section>
        </div>
        <sidebar v-if="!jail"></sidebar>
        <div v-if="!jail" class="side-overlay" @click="toggleSidebar"></div>
    </div>
</template>

<script>
import FooterSection from './components/utilities/FooterSection'
import Navigator from './components/utilities/Navigator'
import Sidebar from './components/utilities/Sidebar'

import Blue from '@/components/theme/Blue'
import Red from '@/components/theme/Red'
import Green from '@/components/theme/Green'

import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'App',
  components: { FooterSection, Navigator, Sidebar, Blue, Red, Green },
  computed: {
    ...mapGetters(['sidebarVisible', 'navigationVisible', 'jail', 'footerHidden']),
    color () {
      if (this.$route.params.theme) {
        return this.$route.params.theme
      } else {
        return 'Blue'
      }
    },
  },
  methods: {
    ...mapMutations(['toggleSidebar', 'toggleNavigation']),
  },
  watch: {
    '$route' (to, from) {
      // Hide mobile navigation panel if route change
      if (this.navigationVisible) {
        this.toggleNavigation()
      }
    },
  },
  beforeCreate () {
    let theme = window.getUrlVars()['theme']
    console.log('theme', theme)
    var styleTag = document.createElement('link')
    styleTag.setAttribute('href', `/static/css/${theme}.css?1234`)
    styleTag.setAttribute('rel', 'stylesheet')
    styleTag.setAttribute('type', 'text/css')
    styleTag.setAttribute('media', 'all')
    document.getElementsByTagName('head')[0].appendChild(styleTag)
    this.$store.dispatch('initLanguages')
  },
}
</script>

<style lang="scss">
    .page-enter-active, .page-leave-active {
        transition: opacity .3s;
    }

    .page-enter, .page-leave-to {
        opacity: 0;
    }
</style>



// WEBPACK FOOTER //
// src/App.vue